// @component ./PadPassword.tsx
export { default as Password } from './PadPassword'
